import { render, staticRenderFns } from "./sizing.vue?vue&type=template&id=384c740e&"
import script from "./sizing.vue?vue&type=script&lang=js&"
export * from "./sizing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports